import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: (p) => p.palette.grey[200],
  padding: (p) => p.spacing(0.5, 0.5, 0.5, 1),
  borderRadius: (p) => p.spacing(0.5),
  height: (p) => p.spacing(4),
};

export const contentWrapper: SxStyleFunc<boolean | undefined> = (disabled) => ({
  opacity: disabled ? '0.3' : 'unset',
});

export const itemIcon: SxStyle = { color: (p) => p.palette.common.black };
export const detailTitle: SxStyle = {
  fontSize: (p) => p.typography.body3,
  color: (p) => p.palette.common.black,
  fontWeight: 500,
};

export const actionIcon: SxStyleFunc<boolean | undefined> = (active) => ({
  color: active ? (p) => p.palette.primary[300] : 'initial',
  cursor: 'pointer',
});

export const titleWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
};

export const addCircleIcon: SxStyle = {
  cursor: 'pointer',
};
